:host {
  display: inline;

  pds-icon {
    margin-inline-start: var(--pine-dimension-2xs);
  }
}

.pds-link {
  align-items: center;
  // Priority: 1) explicit --color prop, 2) context variable, 3) default
  color: var(--color, var(--pds-context-link-color, var(--pine-color-text)));
  display: inline-flex;
  font-weight: var(--pine-font-weight-medium);

  &:focus-visible {
    border-radius: var(--pine-dimension-2xs);
    outline: var(--pine-outline-focus);
    outline-offset: var(--pine-border-width-thick);
    position: relative;
  }

  &:hover {
    color: var(--color, var(--pds-context-link-color-hover, var(--pine-color-text-hover)));
    text-decoration: none;
  }

  :host([color="secondary"]) & {
    color: var(--pine-color-text-primary);

    &:hover {
      color: var(--pine-color-text-inverse-secondary);
    }
  }

  :host([color="accent"]) & {
    color: var(--pine-color-accent);

    &:hover {
      color: var(--pine-color-accent-hover);
    }
  }

  :host([color="danger"]) & {
    color: var(--pine-color-danger);

    &:hover {
      color: var(--pine-color-danger-hover);
    }
  }
}

// We have a small consensus stating that
// fonts will be REMs, box-model will be
// discussed later px or (r)em's
.pds-link--sm {
  font-size: var(--pine-font-size-body-xs);

  pds-icon {
    height: var(--pine-dimension-xs);
    width: var(--pine-dimension-xs);
  }
}

.pds-link--md {
  font-size: var(--pine-font-size-body-sm);

  pds-icon {
    height: var(--pine-dimension-xs);
    width: var(--pine-dimension-xs);
  }
}

.pds-link--lg {
  font-size: var(--pine-font-size-body-md);

  pds-icon {
    height: var(--pine-dimension-sm);
    width: var(--pine-dimension-sm);
  }
}

.pds-link--plain {
  text-decoration: none;

  &:hover {
    color: var(--color, var(--pds-context-link-color-hover, var(--pine-color-text-hover)));
    text-decoration: underline;
  }
}
